module.exports = __webpack_public_path__ + "img/pixel_min.67f8bba0.svg";